import { render } from "./ManualInstall.vue?vue&type=template&id=87d4fc7c"
import script from "./ManualInstall.vue?vue&type=script&lang=js"
export * from "./ManualInstall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__